import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useOrders } from '../DefaultPage/connect/Orders';
import TitileAndArrowBack from '../../components/TitileAndArrowBack/TitileAndArrowBack';
import { Checkbox, Col, Collapse, Radio, Row } from 'antd';
import { useLocations } from '../../States/Location/Location';
import FormatPrice from '../../components/FormatPrice/FormatPricw';
import Num2persian from 'num2persian';
import MapForEditing from '../../components/Map/MapForEditing';

export default function EditforMySelf() {
    const params = useParams();
    const details = useOrders((state) => state.details);
    const { getDetailsOrders, EditforSelf } = useOrders(
        (state) => state.actions
    );
    const { getAllAreas } = useLocations((state) => state.actions);
    const areas = useLocations((state) => state.areas);
    const collapseRef = useRef(null);
    const [activeKey, setActiveKey] = useState(['']);
    const [selectedAreaId, setSelectedAreaId] = useState(null);
    const [areaList, setAreaList] = useState(areas)
    const [adsMainCategoryCode, setAdsMainCategoryCode] = useState(1)
    const [addedBy, setAddedBy] = useState(null)
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedCoordinates, setSelectedCoordinates] = useState(null);
    const [adsTitle, setAdsTitle] = useState(details[0]?.adsTitle);
    const [newPhoneNumber, setNewPhoneNumber] = useState(""); // For adding/editing 
    const [phoneNumbers, setPhoneNumbers] = useState([]); // List of phone numbers
    const [editIndex, setEditIndex] = useState(null); // Track which number is being edited
    const [adsPrptyTradeTypeCode, setAdsPrptyTradeTypeCode] = useState(null)
    const [adsPrptyTypeCode, setAdsPrptyTypeCode] = useState(null)
    const [adsPrptyCategoryCode, setAdsPrptyCategoryCode] = useState(null)
    const [pricePerMeter, setPricePerMeter] = useState(null)
    const [totalPrice, setTotalPrice] = useState(null)
    const [metrage, setMetrage] = useState(null)
    const [numberOfRooms, setNumberOfRooms] = useState(null)
    const [lifeOfTheBuilding, setLifeOfTheBuilding] = useState(null)
    const [floorTo, setFloorTo] = useState(null)
    const [floorFrom, setFloorFrom] = useState(null)
    const [unitPerFloor, setUnitPerFloor] = useState(null)
    const [parking, setParking] = useState(false)
    const [basement, setBasement] = useState(false)
    const [elevator, setElevator] = useState(false)
    const [isApproximateArea, setIsApproximateArea] = useState(null);
    const [deposit, setDeposit] = useState(null);
    const [rent, setRent] = useState(null);
    const [convertingDepositAmount, setConvertingDepositAmount] = useState(null);
    const [convertingRentAmount, setConvertingRentAmount] = useState(null);
    const [abilityToConvert, setAbilityToConvert] = useState(false)
    const [propertyLandMetarage, setPropertyLandMetarage] = useState(null)
    const [squareFootageEntireProperty, setSquareFootageEntireProperty] = useState(null)
    const [propertyWidth, setPropertyWidth] = useState(null)
    const [buyPriceFrom, setBuyPriceFrom] = useState(null)
    const [buyPriceTo, setBuyPriceTo] = useState(null)
    const [metrageFrom, setMetrageFrom] = useState(null)
    const [meterageTo, setMeterageTo] = useState(null)
    const [lifeOfBuildingFrom, setLifeOfTheBuildingFrom] = useState(null)
    const [lifeOfBulidingTo, setLifeOfTheBuildingTo] = useState(null)
    const [rentPriceFrom, setRentPriceFrom] = useState(null)
    const [rentPriceTo, setRentPriceTo] = useState(null)
    const [rentDepositFrom, setRentDepositFrom] = useState(null)
    const [rentDepositTo, setRentDepositTo] = useState(null)
    const [address, setAddress] = useState(null)
    const [fullName, setFullName] = useState(null)
    const [description, setDescription] = useState(details[0]?.description)
    const [selectedAreaName, setSelectedAreaName] = useState(['']);
    const [noPhonenumberError, setNoPhonenumberError] = useState(false);
    const [longPhonenumberError, setLongPhonenumberError] = useState(false);
    const [noTitleError, setNoTitleError] = useState(false);
    const [noPrptyTradeTypeCodeError, setNoPrptyTradeTypeCodeError] = useState(false);
    const [noAdsPrptyTypeCodeError, setNoAdsPrptyTypeCodeError] = useState(false);
    const [noAreaError, setNoAreaError] = useState(false);
    const [noMetrageError, setNoMetrageError] = useState(false);
    const [noPropertyLandMetarageError, setNoPropertyLandMetarageError] = useState(false);
    const [userCode, setUserCode] = useState(0);
    const [abilityToConvertError, setAbilityToConvertError] = useState(false);
    const [landPhone, setLandPhone] = useState("")
    const [adsDateTime, setAdsDateTime] = useState("")
    const [ownerName, setOwnerName] = useState("")
    const [updatedBy, setUpdatedBy] = useState(null)

    const adsPrptyTradeTypeCodes = {
        1: "فروش",
        2: "رهن و اجاره",
        3: "معاوضه",
        4: "مشارکت در ساخت",
        5: "پیش فروش",
        6: "رهن و اجاره کوتاه مدت",
        7: "متقاضی خرید",
        8: "متقاضی اجاره",
    }
    const propertyTypes = {
        1: "آپارتمان مسکونی",
        2: "آپارتمان اداری",
        3: "خانه و ویلا",
        4: "زمین کلنگی",
        5: "مستغلات",
        6: "مغازه",
        7: "صنعتی و کشاورزی",
    };
    const categoryMap = {
        1: { 1: 1, 2: 2, 3: 1, 4: 8, 5: 1, 6: 9, 7: 10, 8: 11 }, // adsPrprtyType: 1
        2: { 1: 1, 2: 2, 3: 1, 4: 8, 5: 1, 6: 1, 7: 10, 8: 11 }, // adsPrprtyType: 2
        3: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: 9, 7: 10, 8: 11 },
        4: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: null, 7: 10, 8: 11 },
        5: { 1: 6, 2: 7, 3: 6, 4: 8, 5: 6, 6: null, 7: 10, 8: 11 },
        6: { 1: 3, 2: 4, 3: 3, 4: 8, 5: 3, 6: null, 7: 10, 8: 11 },
        7: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: 9, 7: 10, 8: 11 },
        // Add other adsPrprtyType and adsPrprtyTradeType mappings here
    };
    function getAdsPrprtyCategory(adsPrprtyType, adsPrprtyTradeType) {
        return categoryMap[adsPrprtyType]?.[adsPrprtyTradeType] ?? null; // Default to null if not found
    }

    const handleSelectDistrict = (selectedDistrictId) => {
        setSelectedAreaId(selectedDistrictId); // Set the selected district ID
    };
    const handleKeyPress2 = (event) => {
        if ((event.key === 'Enter' || event.key === ' ') && collapseRef.current) {
            // Programmatically trigger a click on the Collapse header
            collapseRef.current.click();
            event.preventDefault();
        }
    }
    const handleMapClick = (coords) => {
    

        setSelectedCoordinates(coords);
      
    };
    const handleAdsTitleChange = (value) => {
        setAdsTitle(value)
    }
    const applyChanges = () => {
  

        // EditforSelf(
        //     usruserCode,
        //     adsMasterCode,
        //     countryCode,
        //     stateCode,
        //     cityCode,
        //     areaCode,
        //     latitude,
        //     longitude,
        //     isApproximateArea,
        //     adsTitle,
        //     pricePerMeter,
        //     totalPrice,
        //     propertyLandMetarage,
        //     propertyWidth,
        //     deposit,
        //     squareFootageEntireProperty,
        //     rentPerMonth,
        //     abilityToConvert,
        //     convertingDepositAmount,
        //     convertingRentAmount,
        //     meterage,
        //     numberOfRooms,
        //     lifeOfTheBuilding,
        //     dateForRent,
        //     floorNumber,
        //     totalFloor,
        //     unitPerFloor,
        //     parking,
        //     basement,
        //     elevator,
        //     mobilePhone,
        //     landPhone,
        //     price,
        //     description,
        //     adsDateTime,
        //     registerStatusCode,
        //     searchStrings,
        //     ownerName,
        //     address,
        //     addedBy,
        //     updatedBy,
        //     updatedAt


        // )





        EditforSelf(
            userCode,
            params?.id,
            1,
            2,
            3,
            selectedAreaId,
            selectedCoordinates[0],
            selectedCoordinates[1],
            details[0]?.isApproximateArea,
            adsTitle,
            pricePerMeter,
            totalPrice,
            propertyLandMetarage,
            propertyWidth,
            deposit,
            squareFootageEntireProperty,
            rent,
            abilityToConvert,
            convertingDepositAmount,
            convertingRentAmount,
            metrage,
            numberOfRooms,
            lifeOfTheBuilding,
            /* dateForRent */null,
            floorFrom,
            floorTo,
            unitPerFloor,
            parking,
            basement,
            elevator,
            newPhoneNumber,
            landPhone,
            totalPrice,
            description,
            adsDateTime,
            null,
            24,
            "",
            ownerName,
            address,
            addedBy,
            updatedBy,
            null
        )


    }
    const adsPrptyTradeTypeCodeCollapse = [
        {
            key: '2',
            label: ` نوع معامله   ${adsPrptyTradeTypeCode ? `/` + adsPrptyTradeTypeCodes[adsPrptyTradeTypeCode] : ``} `,
            children:
                <Radio.Group
                    onChange={(e) => {
                        setAdsPrptyTradeTypeCode(e.target.value)
                        setActiveKey([])
                        // setNoPrptyTradeTypeCodeError(false)
                    }

                    } value={adsPrptyTradeTypeCode}
                    className={`flex flex-col `}>
                    <Radio value={1} >فروش</Radio >
                    <Radio value={2} >رهن و اجاره</Radio >
                    <Radio value={3} >معاوضه</Radio >
                    <Radio value={4} >مشارکت در ساخت</Radio >
                    <Radio value={5} >پیش فروش</Radio >
                    <Radio value={6} >رهن و اجاره کوتاه مدت</Radio >
                    <Radio value={7} >متقاضی خرید</Radio >
                    <Radio value={8} >متقاضی اجاره</Radio >
                </Radio.Group>
        },
    ];
    const adsPrptyTypeCodeCollapse = [
        {
            key: '3',
            label: ` نوع ملک ${adsPrptyTypeCode ? `/` + propertyTypes[adsPrptyTypeCode] : ``}`,
            children:
                <Radio.Group
                    onChange={(e) => {
                        console.log(e?.target.value, "hah");
                        // setNoAdsPrptyTypeCodeError(false)
                        setAdsPrptyTypeCode(e.target.value)
                        setActiveKey([])
                    }

                    } value={adsPrptyTypeCode} className='flex flex-col'
                >
                    <Radio value={1} >آپارتمان مسکونی</Radio >
                    <Radio value={2} >آپارتمان اداری</Radio >
                    <Radio value={3} >خانه و ویلا</Radio >
                    <Radio value={4} >زمین کلنگی</Radio >
                    <Radio value={5} >مستغلات</Radio >
                    <Radio value={6} >مغازه</Radio >
                    <Radio value={7} >صنعتی و کشاورزی</Radio >
                </Radio.Group >
        },

    ];
    const districtsCollapse = [
        {
            key: '4',
            label: `محله /${selectedAreaName}`,
            children: (
                <div className='flex items-center justify-around w-full gap-4'>
                    <div>
                        <form>
                            <div className='flex items-center bg-gray-100 p-2 rounded'>
                                <input
                                    onChange={async (e) => {
                                        setAreaList(areas.filter(area => area.locName.includes(e.target.value)));

                                    }}
                                    className='w-full bg-transparent outline-none border-none'
                                    type="text"
                                    placeholder="نام محله"
                                />
                                <button type='submit'>
                                    <img src="/icons/search.svg" alt="جست و جو" />
                                </button>
                            </div>
                        </form>
                        <div className="h-[300px] overflow-y-scroll overflow-x-hidden border-r border-l border-b rounded p-2 w-full">
                            {areaList && areaList.map(area => (
                                <Radio
                                    key={area.id}
                                    value={area.id}
                                    checked={selectedAreaId === area.id} // Assuming selectedAreaId is a single selected district
                                    onChange={() => {
                                        handleSelectDistrict(area.id)
                                        setActiveKey([])
                                        setSelectedAreaName(area?.locName)
                                        setNoAreaError(false)

                                    }} // handleSelectDistrict will set the selected district ID
                                    className="my-2 py-1 border-b hover:bg-gray-100 transition-all w-full"
                                >
                                    <p className="font-bold">{area.locName}</p>
                                    <p className="text-sm text-gray-800">{area.subAreas?.map((item, index) => index === area.subAreas?.length - 1 ? item : `${item}  ،`)}</p>

                                </Radio>
                            ))}
                        </div>
                    </div>
                </div>
            ),
        },
    ];
    const categoriesCollapse = [
        {
            key: '1',
            label: ` دسته بندی /${adsMainCategoryCode !== 8 ? `شخصی` : `تعاون`}  `,
            children:
                <Radio.Group
                    // onChange={(e) => handleCategoryChange(e.target.value)}
                    value={adsMainCategoryCode === 8 ? 2 : 3}
                    className='flex flex-col rtyr'>
                    <Radio value={2} > تعاون</Radio >
                    <Radio value={3} >شخصی </Radio >
                </Radio.Group>
        },
    ];

    ;

    const openModal = [
        {
            key: '2',
            label: (
                // <span onClick={() => handleOpenModal()}>انتخاب موقعیت مکانی از روی نقشه</span>
                <></>
            ),

        },
    ];

    useEffect(() => {
        getDetailsOrders(params?.id)
        getAllAreas(3)
    }, [])

    useEffect(() => {
        console.log("something changed");
        getAdsPrprtyCategory(adsPrptyTypeCode, adsPrptyTradeTypeCode)
        setAdsPrptyCategoryCode(getAdsPrprtyCategory(adsPrptyTypeCode, adsPrptyTradeTypeCode))
        // setAbilityToConvert(false)
    }, [adsPrptyTypeCode, adsPrptyTradeTypeCode])
    useEffect(() => {
        if (areas.length) {
            setAreaList(areas)
        } else {
            getAllAreas(3)
        }

    }, [areas]);

    useEffect(() => {
        if (details[0]) {
            setAdsTitle(details[0]?.adsTitle)
            setAdsPrptyTradeTypeCode(details[0]?.adsPrptyTradeTypeCode)
            setAdsPrptyTypeCode(details[0]?.adsPrptyTypeCode)
            setSelectedAreaName(details[0]?.areaName)
            setAddress(details[0]?.address)
            setMetrage(details[0]?.tblAdsPrptyDetails[0]?.meterage)
            setNumberOfRooms(details[0]?.tblAdsPrptyDetails[0]?.numberOfRooms)
            setLifeOfTheBuilding(details[0]?.tblAdsPrptyDetails[0]?.lifeOfTheBuilding)
            setPricePerMeter(details[0]?.tblAdsPrptyDetails[0]?.pricePerMeter)
            setTotalPrice(details[0]?.tblAdsPrptyDetails[0]?.totalPrice)
            setDeposit(details[0]?.tblAdsPrptyDetails[0]?.deposit)
            setRent(details[0]?.tblAdsPrptyDetails[0]?.rentPerMonth)
            setFloorFrom(details[0]?.tblAdsPrptyDetails[0]?.floorNumber)
            setFloorTo(details[0]?.tblAdsPrptyDetails[0]?.totalFloor)
            setUnitPerFloor(details[0]?.tblAdsPrptyDetails[0]?.unitPerFloor)
            setElevator(details[0]?.tblAdsPrptyDetails[0]?.elevator)
            setBasement(details[0]?.tblAdsPrptyDetails[0]?.basement)
            setParking(details[0]?.tblAdsPrptyDetails[0]?.parking)
            setDescription(details[0]?.tblAdsPrptyDetails[0]?.description)
            setSelectedCoordinates([details[0]?.latitude, details[0]?.longitude])
            setBuyPriceFrom(details[0]?.tblAdsPrptyApplicantRentBuyProperties[0]?.buyPriceFrom)
            setBuyPriceTo(details[0]?.tblAdsPrptyApplicantRentBuyProperties[0]?.buyPriceTo)
            setLifeOfTheBuildingTo(details[0]?.tblAdsPrptyApplicantRentBuyProperties[0]?.lifeOfBulidingTo)
            setLifeOfTheBuildingFrom(details[0]?.tblAdsPrptyApplicantRentBuyProperties[0]?.lifeOfBuildingFrom)
            setMeterageTo(details[0]?.tblAdsPrptyApplicantRentBuyProperties[0]?.meterageTo)
            setMetrageFrom(details[0]?.tblAdsPrptyApplicantRentBuyProperties[0]?.metrageFrom)
            setRentPriceTo(details[0]?.tblAdsPrptyApplicantRentBuyProperties[0]?.rentPriceTo)
            setRentPriceFrom(details[0]?.tblAdsPrptyApplicantRentBuyProperties[0]?.rentPriceFrom)
            setRentDepositTo(details[0]?.tblAdsPrptyApplicantRentBuyProperties[0]?.rentDeposintTo)
            setRentDepositFrom(details[0]?.tblAdsPrptyApplicantRentBuyProperties[0]?.rentDepositFrom)
            setPropertyWidth(details[0]?.tblAdsPrptyDetails[0]?.propertyWidth)
            setSquareFootageEntireProperty(details[0]?.tblAdsPrptyDetails[0]?.squareFootageEntireProperty)
            setPropertyLandMetarage(details[0]?.tblAdsPrptyDetails[0]?.propertyLandMetarage)
            /* ina vse api */
            setUserCode(details[0]?.usruserCode)
            setIsApproximateArea(details[0]?.isApproximateArea)
            setAbilityToConvert(details[0]?.abilityToConvert)
            setConvertingRentAmount(details[0]?.tblAdsPrptyDetails[0]?.convertingRentAmount)
            setConvertingDepositAmount(details[0]?.tblAdsPrptyDetails[0]?.convertingDepositAmount)
            setNewPhoneNumber(details[0]?.mobilePhone)
            setLandPhone(details[0]?.landPhone)
            setAdsDateTime(details[0]?.adsDateTime)
            setOwnerName(details[0]?.ownerName)
            setAddedBy(details[0]?.addedBy)
            setUpdatedBy(details[0]?.updatedBy)
            setSelectedAreaId(details[0]?.areaCode)
        }


    }, [details])
    console.log(selectedCoordinates, "ghabeb shisheE");

    return (
        <div className='px-1'>
            <TitileAndArrowBack title="ویرایش فایل" />
            <div className='grid grid-cols-2 gap-2 my-2'>
                <div className="overflow-hidden whitespace-nowrap text-ellipsis col-span-1">
                    <Collapse items={adsPrptyTradeTypeCodeCollapse} activeKey={activeKey} onChange={(key) => setActiveKey(key)} className='collapse-ProductDetails' />
                </div>
                <div className="overflow-hidden whitespace-nowrap text-ellipsis col-span-1">
                    <Collapse items={adsPrptyTypeCodeCollapse} activeKey={activeKey} onChange={(key) => setActiveKey(key)} className='collapse-ProductDetails' />

                </div>
            </div>
            <div className='w-1/2  lg:flex lg:flex-col mb-2 '>
                <div className='flex flex-col relative col-span-2 pl-1'>

                    {/* <Collapse items={districtsCollapse} activeKey={activeKey} onChange={(key) => setActiveKey(key)} className='w-[350px] ml-1  absolute collapse-ProductDetails' /> */}
                    <div
                        tabIndex={0} // Make the wrapper focusable
                        // onFocus={() => {
                        //   if (collapseRef.current) {
                        //     collapseRef.current.focus(); // Focus directly on the Collapse header
                        //     setIsFocused(true)
                        //   }
                        // }}
                        onFocus={(e) => {
                            if (e.target.tagName !== 'INPUT') { // Prevent triggering if the focus is on the input
                                if (collapseRef.current) {
                                    collapseRef.current.focus(); // Focus directly on the Collapse header

                                }
                            }
                        }}
                        onKeyDown={handleKeyPress2} // Open Collapse on Enter/Space
                        className={`relative w-full ml-1 collapse-wrapper focus:outline-2`}
                    >
                        <Collapse
                            activeKey={activeKey}
                            onChange={(key) => setActiveKey(key)}
                            className={`collapse-ProductDetails focus:outline-blue-500 focus:bg-blue-300`}
                            items={districtsCollapse.map((item) => ({
                                ...item,
                                label: (
                                    <span
                                        tabIndex={-1} // Prevent label itself from being focusable
                                        ref={collapseRef}
                                        className=" "
                                    >
                                        {item.label}
                                    </span>
                                ),
                            }))}
                        />
                    </div>
                </div>
            </div>
            <div> {
                (adsPrptyCategoryCode !== 7 && adsPrptyCategoryCode !== 8) && <>
                    <div className="col-span-2 border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474] flex flex-wrap gap-2 rounded flex-1 max-h-[34px]  z-10">
                        <label className="flex-none">    آدرس</label>
                        <input
                            onChange={(e) => setAddress(e.target.value)}
                            value={address}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white "

                        />
                    </div>
                </>
            }</div>

            <div className="col-span-2 border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474] flex flex-wrap gap-2 rounded flex-1 max-h-[34px]  z-10 my-2">

                <input
                    onChange={(e) => setAdsTitle(e.target.value)}
                    value={adsTitle}
                    className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"

                />
            </div>
            {
                (adsPrptyCategoryCode === 10) &&
                <div className='grid grid-cols-2 gap-2 my-2'>
                    <div>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  قیمت از  </label>
                            <input

                                value={buyPriceFrom} // Format the displayed value
                                onChange={(e) => {
                                    setBuyPriceFrom(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>
                        {buyPriceFrom ? (
                            <p className="px-3 text-[12px] text-green-600">
                                {Num2persian(buyPriceFrom)} تومان
                            </p>
                        ) : null}
                    </div>
                    <div>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  قیمت تا  </label>
                            <input

                                value={buyPriceTo} // Format the displayed value
                                onChange={(e) => {
                                    setBuyPriceTo(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>
                        {buyPriceTo ? (
                            <p className="px-3 text-[12px] text-green-600">
                                {Num2persian(buyPriceTo)} تومان
                            </p>
                        ) : null}
                    </div>
                </div>
            }
            {
                (adsPrptyCategoryCode === 11) &&
                <div className='grid grid-cols-4 my-2 gap-2'>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                        <label className="flex-none">  ودیعه از  </label>
                        <input

                            value={rentDepositFrom} // Format the displayed value
                            onChange={(e) => {
                                setRentDepositFrom(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                        <label className="flex-none">  ودیعه تا  </label>
                        <input

                            value={rentDepositTo} // Format the displayed value
                            onChange={(e) => {
                                setRentDepositTo(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>


                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                        <label className="flex-none">  اجاره از  </label>
                        <input

                            value={rentPriceFrom} // Format the displayed value
                            onChange={(e) => {
                                setRentPriceFrom(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                        <label className="flex-none">  اجاره تا  </label>
                        <input

                            value={rentPriceTo} // Format the displayed value
                            onChange={(e) => {
                                setRentPriceTo(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>
                </div>
            }
            {
                (adsPrptyCategoryCode === 10 || adsPrptyCategoryCode === 11) &&
                <div className='grid grid-cols-4 gap-2'>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                        <label className="flex-none">  متراژ از  </label>
                        <input

                            value={metrageFrom} // Format the displayed value
                            onChange={(e) => {
                                setMetrageFrom(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                        <label className="flex-none">  متراژ تا  </label>
                        <input

                            value={meterageTo} // Format the displayed value
                            onChange={(e) => {
                                setMeterageTo(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                        <label className="flex-none"> عمر بنا از</label>
                        <input

                            value={lifeOfBuildingFrom} // Format the displayed value
                            onChange={(e) => {
                                setLifeOfTheBuildingFrom(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                        <label className="flex-none">   تا  </label>
                        <input

                            value={lifeOfBulidingTo} // Format the displayed value
                            onChange={(e) => {
                                setLifeOfTheBuildingTo(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>



                </div>
            }
            {(adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 3 || adsPrptyCategoryCode === 4) &&
                <div className=' col-span-4 grid gap-2 gap-y-2 grid-cols-3 xl:col-span-9'>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full  xl: " >
                        <label className="flex-none">  متراژ</label>
                        <input

                            value={metrage} // Format the displayed value
                            onChange={(e) => {
                                setMetrage(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />
                        {noMetrageError && <p className='text-sm text-red-800'> متراژ  نمیتواند خالی باشد</p>}

                    </div>

                    <div className="border border-[#D1D1D1] p-1  rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full xl:" >
                        <label className="flex-none">  تعداد اتاق</label>
                        <input

                            value={numberOfRooms} // Format the displayed value
                            onChange={(e) => {
                                setNumberOfRooms(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full xl:" >
                        <label className="flex-none">  عمر بنا  </label>
                        <input

                            value={lifeOfTheBuilding} // Format the displayed value
                            onChange={(e) => {
                                setLifeOfTheBuilding(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>
                </div>}

            {(adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 3 || adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6) &&
                <div className='grid grid-cols-8 gap-2 col-span-8'>
                    <div className='col-span-8 my-2'>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px]" >
                            <label className="flex-none"> قیمت متری</label>
                            <input

                                value={FormatPrice(pricePerMeter)} // Format the displayed value
                                onChange={(e) => {
                                    const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                    setPricePerMeter(rawValue); // Set the raw numeric value in Formik state
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>
                        {pricePerMeter ? (
                            <p className="px-3 text-[12px] text-green-600">
                                {Num2persian(pricePerMeter)} تومان
                            </p>
                        ) : null}
                    </div>

                    <div className='col-span-8  my-2'>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px]  " >

                            <label className="flex-none"> قیمت کل</label>
                            <input

                                value={FormatPrice(totalPrice)} // Format the displayed value
                                onChange={(e) => {
                                    const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                    setTotalPrice(rawValue); // Set the raw numeric value in Formik state
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>
                        {totalPrice ? (
                            <p className="px-3 text-[12px] text-green-600">
                                {Num2persian(totalPrice)} تومان
                            </p>
                        ) : null}
                    </div>
                </div>
            }
            {(adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 4 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12) &&

                <div className='grid grid-cols-4 gap-2'>
                    <div className='col-span-2'>
                        <div className="  border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none"> ودیعه</label>
                            <input

                                value={FormatPrice(deposit)} // Format the displayed value
                                onChange={(e) => {
                                    const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                    setDeposit(rawValue); // Set the raw numeric value in Formik state
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>
                        {deposit ? (
                            <p className="px-3 text-[12px] text-green-600">
                                {Num2persian(deposit)} تومان
                            </p>
                        ) : null}
                    </div>

                    <div className='col-span-2'>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  اجاره</label>
                            <input

                                value={FormatPrice(rent)} // Format the displayed value
                                onChange={(e) => {
                                    const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                    setRent(rawValue); // Set the raw numeric value in Formik state
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>
                        {rent ? (
                            <p className="px-3 text-[12px] text-green-600">
                                {Num2persian(rent)} تومان
                            </p>
                        ) : null}
                    </div>










                </div>
            }

            <div className='grid grid-cols-2 gap-2 my-2'>
                {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12) && <>
                    <div>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  متراژ زمین </label>
                            <input

                                value={propertyLandMetarage} // Format the displayed value
                                onChange={(e) => {
                                    setPropertyLandMetarage(e.target.value)
                                    setNoPropertyLandMetarageError(false)
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>
                        {noPropertyLandMetarageError && <p className='text-sm text-red-800'> متراژ زمین  نمیتواند خالی باشد</p>}
                    </div>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                        <label className="flex-none">  متراژ زیر بنای کل</label>
                        <input

                            value={squareFootageEntireProperty} // Format the displayed value
                            onChange={(e) => {
                                setSquareFootageEntireProperty(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>
                </>}
                {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 8 || adsPrptyCategoryCode === 12) && <>
                    {adsPrptyCategoryCode === 8 &&
                        <>
                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                <label className="flex-none">  متراژ</label>
                                <input

                                    value={metrage} // Format the displayed value
                                    onChange={(e) => {
                                        setMetrage(e.target.value)
                                        setNoMetrageError(false)

                                    }}
                                    className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                                />

                            </div>
                        </>
                    }

                    {adsPrptyCategoryCode === 12 || adsPrptyCategoryCode === 8 &&
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none"> عرض ملک</label>
                            <input

                                value={propertyWidth} // Format the displayed value
                                onChange={(e) => {
                                    setPropertyWidth(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>
                    }

                </>}
                {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12) && <>
                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                        <label className="flex-none"> عمر بنا  </label>
                        <input

                            value={lifeOfTheBuilding} // Format the displayed value
                            onChange={(e) => {
                                setLifeOfTheBuilding(e.target.value)
                            }}
                            className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                        />

                    </div>

                </>}

            </div>
            <div className='grid grid-cols-6 gap-2 pb-9'>
                {
                    (adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2) &&
                    <div className='col-span-6 grid grid-cols-6 gap-2 xl:mb-2'>
                        <div className="col-span-3 border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  طبقه چندم از   </label>
                            <input

                                value={floorFrom} // Format the displayed value
                                onChange={(e) => {
                                    setFloorFrom(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>

                        <div className="col-span-3 border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  تعداد کل طبقات </label>
                            <input

                                value={floorTo} // Format the displayed value
                                onChange={(e) => {
                                    setFloorTo(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>
                    </div>
                }

                {(adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7) &&
                    <>


                        <div className="border border-[#D1D1D1] p-1 px-2  rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  تعداد طبقات ساختمان</label>
                            <input

                                value={floorTo} // Format the displayed value
                                onChange={(e) => {
                                    setFloorTo(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>

                    </>}
                {
                    (adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7) &&
                    <div className='col-span-6 '>
                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                            <label className="flex-none">  واحد در طبقه   </label>
                            <input

                                value={unitPerFloor} // Format the displayed value
                                onChange={(e) => {
                                    setUnitPerFloor(e.target.value)
                                }}
                                className="flex-1 outline-none w-full text-black dark:!bg-transparent dark:!text-white"
                            />

                        </div>
                    </div>
                }

                <>
                    <Row className=' w-full col-span-6'>
                        <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                            <Checkbox checked={parking} onClick={() => setParking(!parking)} value="1">پارکینگ</Checkbox>
                        </Col>
                        <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                            <Checkbox checked={basement} onClick={() => setBasement(!basement)} value="2">انباری</Checkbox>
                        </Col>
                        <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                            <Checkbox checked={elevator} onClick={() => setElevator(!elevator)} value="3">آسانسور</Checkbox>
                        </Col>
                    </Row>
                </>
                <div className='grid grid-cols-6 col-span-6 gap-2 mx-1 lg:flex lg:flex-col mb-14 '>
                    <div className='mt-2 col-span-3'>
                        <label>توضیحات</label>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={8}
                            className='px-1 py-2 text-[13px] w-full border border-[#D1D1D1] outline  outline-[#D1D1D1] rounded dark:!text-black' />
                    </div>
                    {(adsPrptyCategoryCode !== 10 && adsPrptyCategoryCode !== 11) &&
                        <div className='col-span-3 mt-7'>
                            <MapForEditing
                                position={

                                    selectedCoordinates
                                }
                                routing="false"
                                zoom="13"
                                onMapClick={handleMapClick}
                                selectedAreaId={selectedAreaId}
                                isInCreateAdPage={true}
                            />
                        </div>
                    }

                </div>

                <div className='w-full flex fixed bg-white bottom-0 '>

                    <button
                        className='bg-[#F4F4F4] text-[#039600] justify-center mx-auto py-2 px-3 rounded-lg my-3'
                        onClick={() => applyChanges()}
                    >اعمال تغییرات</button>

                </div>
            </div>
        </div>
    )
}
